import { Fragment } from 'react'
import {
	Listbox,
	ListboxButton,
	Label,
	ListboxOptions,
	ListboxOption,
} from '@headlessui/react'
import { CaretDown, FilterIcon, RadioCircleFilledIcon } from '../icons'
import TypographyLabel from '../typography/TypographyLabel'
import clsx from 'clsx'
import { twMerge } from 'tailwind-merge'

const filterOptions = [
	{ title: 'Number (Low to High)', description: 'Sort by number low to high' },
	{ title: 'Number (High to Low)', description: 'Sort by number hight to low' },
]

const Filter = ({
	options = filterOptions,
	type = 'Sort',
	value,
	onChange = () => {},
}: {
	options: { title: string; description: string; optionCount?: number }[]
	type: 'Sort' | 'Filter'
	value?: { title: string; description: string; optionCount?: number }
	onChange?: (newVal: any) => void
}) => {
	// If value is undefined, use the first option as default
	const currentValue = value || options[0]

	return (
		<Listbox value={currentValue} onChange={onChange}>
			{({ open }) => (
				<>
					<Label className="sr-only">Change filter value</Label>
					<div className="group relative">
						<div
							className={clsx(
								'inline-flex rounded-full shadow-sm ',
								open
									? 'bg-textPrimaryLight text-textPrimaryDark ring-0 dark:bg-textPrimaryDark dark:text-textPrimaryLight'
									: 'bg-light text-textPrimaryLight ring-1 ring-inset ring-textInactiveLight group-hover:bg-textPrimaryLight group-hover:text-textPrimaryDark dark:bg-dark  dark:text-textPrimaryDark dark:ring-textInactiveDark group-hover:dark:bg-textPrimaryDark group-hover:dark:text-textSecondaryLight',
							)}
						>
							<ListboxButton className="">
								<>
									{/*Button for small screens*/}
									<div
										className={clsx(
											'flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border border-textInactiveLight transition-colors hover:border-textPrimaryDark hover:bg-textPrimaryLight hover:text-textPrimaryDark dark:border-textPrimaryDark dark:text-textPrimaryDark dark:hover:border-textPrimaryLight dark:hover:bg-textPrimaryDark dark:hover:text-textPrimaryLight',
											'transition-all sm:hidden',
											open
												? 'dark:uiPrimaryLight bg-uiPrimaryDark text-textPrimaryDark dark:text-textPrimaryLight'
												: 'bg-transparent',
											open
												? 'text-textPrimaryDark dark:text-textPrimaryLight'
												: 'text-textPrimaryLight dark:text-textPrimaryDark',
										)}
									>
										<FilterIcon />
									</div>
									{/*Button for medium and large screens*/}
									<div className="hidden cursor-pointer items-center gap-x-2 px-4 py-2 sm:inline-flex">
										<div className="inline-flex items-center">
											<TypographyLabel size="medium" additionalClasses="mr-1">
												{type}:
											</TypographyLabel>
											<TypographyLabel
												size="medium"
												isBold={true}
												additionalClasses="whitespace-nowrap"
											>
												{currentValue.title}
											</TypographyLabel>
										</div>
										<span className="sr-only">Change filter value</span>
										<CaretDown className="text-textSecondaryLight dark:text-textPrimaryDark" />
									</div>
								</>
							</ListboxButton>
						</div>
						<ListboxOptions
							modal={false}
							className="absolute right-0 z-50 mt-2 w-72 origin-top-right divide-y divide-grey300 overflow-hidden rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
						>
							{options.map(option => (
								<ListboxOption
									key={option.title}
									as={Fragment}
									disabled={
										option.optionCount !== undefined
											? option.optionCount === 0
												? true
												: false
											: false
									}
									// @ts-ignore
									// anchor="bottom"
									// transition
									className={({ focus, disabled }) =>
										twMerge(
											focus
												? 'bg-textPrimaryDark text-textPrimaryLight dark:bg-textPrimaryDark dark:text-textPrimaryLight'
												: 'bg-textPrimaryDark text-textPrimaryLight dark:bg-textPrimaryLight dark:text-textPrimaryDark',
											'select-none p-4 text-sm',
											disabled ? 'cursor-not-allowed' : 'cursor-pointer',
											// disabled ? 'cursor-not-allowed text-textInactiveDark dark:text-textInactiveLight bg-grey300 dark:bg-grey600' : 'cursor-pointer',
											// "origin-top transition duration-200 ease-out data-[closed]:scale-95 data-[closed]:opacity-0"
										)
									}
									value={option}
								>
									{/* @ts-ignore */}
									{({ selected, focus }) => {
										return (
											<div className="flex flex-col">
												<div className="flex justify-between">
													<TypographyLabel size="small" isBold={selected}>
														{option.title}
														{option.optionCount !== undefined ? (
															<span
																className={clsx(
																	focus
																		? 'text-textPrimaryDark dark:text-textSecondaryLight'
																		: 'text-textSecondaryLight dark:text-textSecondaryDark',
																	'text-labelsmall font-abc font-normal',
																)}
															>{` (${option.optionCount})`}</span>
														) : (
															''
														)}
													</TypographyLabel>
													{selected ? (
														<span
															className={
																focus
																	? 'text-textPrimaryDark dark:text-textPrimaryLight'
																	: 'text-textPrimaryLight dark:text-textPrimaryDark'
															}
														>
															<RadioCircleFilledIcon size="small" />
														</span>
													) : (
														''
													)}
												</div>
											</div>
										)
									}}
								</ListboxOption>
							))}
						</ListboxOptions>
					</div>
				</>
			)}
		</Listbox>
	)
}

export default Filter
